import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/delivery_container/list_containers/${organization_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchContainers(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/delivery_container/list_containers/${organization_id}/fetch_containers/${agro_exporter_process_id}`
    );
  }
};
